import { Steps } from "antd";
import { useTranslation } from "react-i18next";
import { stagesDataTransformer } from "containers/pmaOnboarding/services/data.transformers";

const OnbSteps = ({
  data,
  failed,
  name,
  stepStage,
  goToCurrentStage,
  onChangeContractStates,
}) => {
  const { t } = useTranslation();

  return (
    <div className="px-10 text-center min-h-[400px]">
      <span className="text-gray-4 body-16px-demibold">
        {`${t("pma-onboarding.creating-asset-steps")} ${name}`}
      </span>

      <Steps
        className="pma-steps mt-6"
        direction="vertical"
        size="small"
        status={failed && "error"}
        current={stepStage}
        percent={100}
        items={stagesDataTransformer(data, stepStage, {
          goToCurrentStage,
          t,
          onChangeContractStates,
        })}
        responsive={false}
      />
    </div>
  );
};
export default OnbSteps;
